import type MuxPlayerElement from '@mux/mux-player'

/** What the room reads from and asks of a `<mux-player>`: the media element's own surface, and its full screen. */
export type MuxPlayerLike = EventTarget & Pick<
    MuxPlayerElement,
    'play' | 'pause' | 'paused' | 'ended' | 'readyState' | 'currentTime' | 'duration' | 'muted' | 'requestFullscreen'
>

let loading: Promise<void> | null = null

/**
 * Defines `<mux-player>` the first time a player mounts. It is imported on demand, so the dashboard fetches its chunk
 * (`vendor_mux`) only when someone opens a player; the viewer bundle inlines it. A failed load is forgotten, so the
 * next player to mount asks again.
 */
export function loadMuxPlayer(): Promise<void> {
    loading ??= import('@mux/mux-player')
        .then(() => customElements.whenDefined('mux-player'))
        .then(
            () => undefined,
            (error: unknown) => {
                loading = null
                throw error
            },
        )
    return loading
}
